const faqs = [
  {
    q: '91吃瓜爆料网是做什么的？',
    a: '91吃瓜爆料网是一个专注于娱乐八卦资讯聚合的平台，为吃瓜群众提供最新、最快、最全面的明星爆料、综艺内幕、影视动态等娱乐资讯。我们7×24小时实时追踪全网热点，深度挖掘事件背后的真相。',
  },
  {
    q: '如何找到91吃瓜网的最新官网入口？',
    a: '本页面即为91吃瓜爆料网的官方首页与最新网址导航。建议您将本页面加入浏览器收藏夹，或关注我们的官方社交媒体账号获取最新入口信息。我们始终为吃瓜群众保障安全、稳定的访问通道。',
  },
  {
    q: '我可以投稿爆料吗？如何操作？',
    a: '当然可以！我们非常欢迎吃瓜群众踊跃投稿。你可以通过页面"投稿爆料"模块中的邮箱或微信联系我们。所有爆料内容严格保密，优质独家爆料一经采纳，将获得专属奖励。',
  },
  {
    q: '91吃瓜网的爆料内容可信度如何？',
    a: '我们的内容来自全网50余个核心信源的多方交叉验证。对于每一条爆料，采编团队都会进行初步核实后再发布。但娱乐资讯瞬息万变，我们建议吃瓜群众理性吃瓜，独立判断。',
  },
  {
    q: '移动端如何使用91吃瓜爆料网？',
    a: '91吃瓜爆料网完美适配手机浏览器访问。此外，我们还提供iOS和Android专属客户端下载，为你带来更流畅的浏览体验和及时的推送通知。扫描页面上"手机吃瓜"模块中的二维码即可下载。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-8 md:mb-10">
          常见问题
        </h2>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((item, idx) => (
            <details
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 text-sm md:text-base font-medium text-foreground-900 list-none">
                <span className="pr-8">{item.q}</span>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-100 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-600 group-open:rotate-180 transition-transform duration-200"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-500 leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}